module.exports = __webpack_public_path__ + "static/media/used-print-header.07903b61.jpg";